var _path, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMainLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    viewBox: "0 0 40 61",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3076 9.80682H40.3636C43.4012 9.80682 45.8636 12.2693 45.8636 15.3068V36.3628C45.8636 39.4004 43.4012 41.8628 40.3636 41.8628H19.3076C16.27 41.8628 13.8076 39.4004 13.8076 36.3628V15.3068C13.8076 12.2693 16.27 9.80682 19.3076 9.80682Z",
    fill: "url(#paint0_linear_12_1116)",
    stroke: "#C4C4C4",
    strokeWidth: 5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12_1116)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 26.966,
    height: 26.966,
    rx: 7,
    fill: "url(#paint1_linear_12_1116)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 1.5,
    width: 23.966,
    height: 23.966,
    rx: 5.5,
    stroke: "#E5E5E5",
    strokeWidth: 3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_12_1116)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.0342,
    y: 25.0367,
    width: 26.966,
    height: 26.966,
    rx: 7,
    fill: "url(#paint2_linear_12_1116)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5342,
    y: 26.5367,
    width: 23.966,
    height: 23.966,
    rx: 5.5,
    stroke: "#E5E5E5",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12_1116",
    x: 0,
    y: 0,
    width: 34.9658,
    height: 34.966,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12_1116"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12_1116",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_12_1116",
    x: 25.0342,
    y: 25.0367,
    width: 34.9658,
    height: 34.966,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12_1116"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12_1116",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_1116",
    x1: 11.3076,
    y1: 25.8348,
    x2: 48.3636,
    y2: 25.8348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3CFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12_1116",
    x1: 4,
    y1: 13.483,
    x2: 30.966,
    y2: 13.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005BEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12_1116",
    x1: 29.0342,
    y1: 38.5197,
    x2: 56.0002,
    y2: 38.5197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC32E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7918F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4801FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogo);
export default __webpack_public_path__ + "static/media/mainLogo.e29e2701a8b19d5611786b3252a0dc50.svg";
export { ForwardRef as ReactComponent };